export default {
  "catalogUrl": "https://sitn.ne.ch/services/stac/catalog.json",
  "catalogTitle": "Catalogue STAC du SITN",
  "catalogImage": "https://sitn.ne.ch/services/stac/assets/logo-sitn.svg",
  "pathPrefix": "/stac/",
  "historyMode": "history",
  "locale": "fr-CH",
  "fallbackLocale": "en",
  "supportedLocales": [
    "fr-CH",
    "de-CH",
    "it-CH",
    "en"
  ],
  "detectLocaleFromBrowser": true,
  "itemsPerPage": 24,
  "searchResultsPerPage": 24,
  "defaultThumbnailSize": [
    200,
    200
  ],
  "footerLinks": [
    {
      "label": "Guide d'utilisation",
      "url": "https://sitn.ne.ch/services/stac/assets/guide/"
    },
    {
      "label": "User guide",
      "url": "https://sitn.ne.ch/services/stac/assets/guide/en.html"
    },
    {
      "label": "SITN",
      "url": "https://sitn.ne.ch/"
    },
    {
      "label": "Conditions d'utilisation",
      "url": "https://sitn.ne.ch/web/conditions_utilisation/contrat_SITN_MO.htm"
    }
  ]
};
